export default function SectionLabel({ number, label, className = "" }) {
    return (
        <div className={`flex items-center gap-4 ${className}`} data-testid={`section-label-${label?.toLowerCase().replace(/\s+/g, "-")}`}>
            <span className="rule-gold" />
            {number && <span className="font-serif text-gold text-lg leading-none">{number}</span>}
            <span className="overlabel text-earth">{label}</span>
        </div>
    );
}
